import { render, staticRenderFns } from "./NumberDisplay.vue?vue&type=template&id=51e8efc2&scoped=true&"
import script from "./NumberDisplay.vue?vue&type=script&lang=js&"
export * from "./NumberDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51e8efc2",
  null
  
)

export default component.exports